"use client";

import { EdgeFade } from "@/components/edge-fade";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

import { BLUR_DATA_URL } from "@/config/site";
import Image from "next/image";

const SLIDE_IMAGES = [
  {
    src: "/images/banners/booking-expert-promo-1.png",
    alt: "Booking Expert flight deals banner",
  },
  {
    src: "/images/banners/booking-expert-promo-2.png",
    alt: "Booking Expert hotel stays banner",
  },
  {
    src: "/images/banners/booking-expert-promo-3.png",
    alt: "Booking Expert visa support banner",
  },
  {
    src: "/images/banners/booking-expert-promo-4.png",
    alt: "Booking Expert holiday packages banner",
  },
];

const PromoSlideCard = ({ image }: { image: (typeof SLIDE_IMAGES)[0] }) => (
  <CarouselItem className="md:basis-1/3">
    <div className="relative h-40 overflow-hidden rounded-md ">
      <Image
        fill
        src={image.src}
        alt={image.alt}
        className="object-cover"
        placeholder="blur"
        blurDataURL={BLUR_DATA_URL}
        sizes="(min-width: 768px) 33vw, 100vw"
        quality={70}
        loading="lazy"
      />
    </div>
  </CarouselItem>
);

export function PromoSlider() {
  return (
    <Carousel className="w-full px-2 relative">
      <EdgeFade edges={["left", "right"]} xSizeClass="w-5" />
      <CarouselContent className="py-4 ">
        {SLIDE_IMAGES.map((image) => (
          <PromoSlideCard key={image.src} image={image} />
        ))}
      </CarouselContent>
    </Carousel>
  );
}
